import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createResponsiveStateReducer } from "redux-responsive";

import property from "./redux/reducers/property";
import app from "./redux/reducers/app";

const rootReducer = combineReducers({
  browser: createResponsiveStateReducer(),
  property,
  app,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["app"],
};

export default persistReducer(persistConfig, rootReducer);
